var map = {
	"./icon-arrow.svg": 403,
	"./icon-arrowthin.svg": 5234,
	"./icon-avatar.svg": 4643,
	"./icon-back.svg": 4057,
	"./icon-calendar.svg": 4498,
	"./icon-channel.svg": 8377,
	"./icon-close.svg": 7668,
	"./icon-cross.svg": 6824,
	"./icon-danger.svg": 385,
	"./icon-dashboard-default.svg": 5772,
	"./icon-document.svg": 1843,
	"./icon-drag.svg": 9534,
	"./icon-edit.svg": 8340,
	"./icon-explore.svg": 4381,
	"./icon-filter.svg": 9438,
	"./icon-filters.svg": 2609,
	"./icon-folders.svg": 6159,
	"./icon-fullscreen-close.svg": 9400,
	"./icon-fullscreen.svg": 5899,
	"./icon-gear.svg": 8897,
	"./icon-gears.svg": 1728,
	"./icon-globe.svg": 3031,
	"./icon-glossary.svg": 3008,
	"./icon-help.svg": 8657,
	"./icon-info.svg": 5484,
	"./icon-logout.svg": 8290,
	"./icon-marketshare.svg": 6961,
	"./icon-organigram.svg": 9313,
	"./icon-person.svg": 4591,
	"./icon-plus-circle.svg": 5501,
	"./icon-plus.svg": 9184,
	"./icon-promo.svg": 9493,
	"./icon-refresh.svg": 3897,
	"./icon-reset.svg": 7293,
	"./icon-shopper.svg": 4257,
	"./icon-support.svg": 3397,
	"./icon-target.svg": 2931,
	"./icon-text.svg": 1285,
	"./icon-tree.svg": 920,
	"./icon-trend-up.svg": 4865,
	"./icon-trend.svg": 3669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9204;